import { clsx } from 'clsx';
import sharedStyles from 'src/common/components/GridCard/_shared-styles.module.scss';

import styles from './CardPlaceholder.module.scss';

interface Props {
  className?: string;
  format?: 'square' | 'card';
}

const ProductPlaceholder = ({ format = 'card', className }: Props) => (
  <div
    className={clsx(styles.container, className)}
    style={{
      aspectRatio:
        format === 'square' ? sharedStyles['CARD_RATIO-square'] : sharedStyles['CARD_RATIO-card'],
    }}></div>
);

export default ProductPlaceholder;
